<div class="menu-header bg-[#205618]">
  <div [class]="logoContainer">
    <img src="./assets/inbetween-logo.png" />
  </div>

  <app-profile></app-profile>
</div>